import sha256 from 'crypto-js/sha256'
import Base64 from 'crypto-js/enc-base64'
import bcrypt from 'bcryptjs'
import hmacSHA256 from 'crypto-js/hmac-sha256'
import useIEHelper from '@/commons/ie-helper'
import { buildWLParam } from '@/commons/whitelabel'
const { URLSearchParamsWrapper } = useIEHelper()
export default {
  data () {
    return {
      errorLink: null,
      code2FA: '',
      password: '',
      visiblePassword: false,
      loginStep: null,
      intendedDestination: null,
      console: console,
      loginEmailSent: false,
      passChallenge: 'no',
      cNonce: '',
      salt: '',
      nonce: '',
      mode: '',
      restoreTokenSend: false,
      info: null,
      showEmailField: false,
      emailRestore: '',
      defaultMethods: null,
      methodsHidden: false
    }
  },
  beforeMount () {
    this.urlParams = URLSearchParamsWrapper(window.location.search)
    this.cNonce = this.clientNonce()
    let data = {
      cnonce: this.cNonce || this.randomString(11)
    }
    this.$axios.post('cnonce', data)
      .then((response) => {
        if (response.status !== 200) {
          let notOk = 'notOk'
          throw notOk
        }
      })
      .catch((error) => {
        this.$log.error(error)
        const err = typeof error === 'object' ? String(Object.values(error)) : String(error)
        window.location.href = '/error?error=' + err + '&hl=' + this.locale + '&error_message=Unexpected' + buildWLParam(this.$wlDomain)
      }).finally(() => {
        this.cNonce = data.cnonce
      })
    this.loginStep = this.step()
    this.intendedDestination = this.destination()
    this.accessMethods = this.lMethods()
    this.email = this.username() || decodeURIComponent(this.urlParams.get('email') || '') || this.email || ''
    this.email = this.email.includes('@') ? this.email : ''
    this.emailRestore = this.email
    this.completeLoginMethods()
    let dLM = this.defaultLoginMethods()
    if (dLM) {
      let defaultMethods = dLM.split(' ')
      this.defaultMethods = this.accessMethods.filter(m => {
        return !!(m.oauth2_access_method && defaultMethods.includes('oidc:' + m.oauth2_access_method.id)) ||
          defaultMethods.includes(m.type)
      })
      if (this.defaultMethods && this.defaultMethods.length === 0) {
        this.defaultMethods = null
      }
    }
    this.methodsHidden = this.defaultMethods ? this.accessMethods.length > this.defaultMethods.length : false
    this.$log.log(this.accessMethods)
    this.mode = this.twoFAmode()
    this.info = this.infoMessage()
  },
  mounted () {
    this.showEmailField = !!this.email
  },
  computed: {
    locale () {
      return this.$root.$i18n.locale
    }
  },
  watch: {
    defaultMethods (val) {
      if (!val) {
        this.methodsHidden = false
      }
    },
    loginStep: function (newVal, oldVal) {
      if (oldVal != null) {
        this.errorMessage = ''
      }
    },
    code2FA (val) {
      if (val.includes(' ')) {
        this.code2FA = val.replace(/\s/g, '')
      }
    },
    passChallenge (val, old) {
      this.$log.log('newpassChallenge: ', val, 'oldpassChallenge: ', old)
    },
    loginEmailSent () {
      this.$root.$emit('reset')
    },
    info (val) {
      if (val === 'RestoreTokenSend') {
        this.restoreTokenSend = true
      }
    }
  },
  methods: {
    getChallenge () {
      let passInfo = this.accessMethods.find(method => method.type === 'password').password_access_method
      let iterations = passInfo.iterations || '08'
      let hsh = passInfo.method || '2a'
      if (typeof iterations === 'number') {
        iterations = iterations.toString()
      }
      if (iterations.length < 2) {
        iterations = '0' + iterations
      }
      let salt = '$' + hsh + '$' + iterations + '$' + passInfo.salt
      let hashedPass = sha256(this.password)
      bcrypt.hash(Base64.stringify(hashedPass), salt, (err, hash) => {
        if (err) {
          this.errorMessage = this.$tf('An internal error occurred, please try again or if the error persists contact the support team')
          this.$log.error(err)
          return
        }
        this.$log.log('hash: ', hash, 'salt: ', salt, 'iterations: ', iterations)
        this.$log.log('cnonce: ', this.cNonce, 'nonce: ', passInfo.nonce)
        let hashedHash = hmacSHA256(hash.substring(29), this.cNonce + passInfo.nonce)
        this.$log.log('hmac: ', hashedHash.toString())
        let xor = sha256('')
        this.$log.log('xor: ', xor)
        for (let i = 0; i < xor.words.length; i++) {
          xor.words[i] = hashedPass.words[i] ^ hashedHash.words[i]
        }
        this.$log.log('xor: ', xor.toString())
        this.passChallenge = xor.toString()
        this.$nextTick(() => {
          this.submitForm('login-form')
        })
        this.$forceUpdate()
      })
    },
    step () {
      return this.urlParams ? this.urlParams.get('step') || '' : ''
    },
    destination () {
      return this.urlParams.get('dest') || null
    },
    username () {
      return decodeURIComponent(this.urlParams.get('username')) || null
    },
    clientNonce () {
      return this.urlParams.get('cnonce') || this.cNonce
    },
    infoMessage () {
      return this.urlParams.get('info_message') || null
    },
    twoFAmode () {
      return this.urlParams.get('mode') || this.$tf('preferred method')
    },
    sendEmail () {
      if (!this.$refs['email-form'].$refs.form.validate()) {
        this.$log.error('Invalid form')
        return
      }
      this.$axios.post('access-methods?username=' + encodeURIComponent(this.email) + '&hl=' + encodeURIComponent(this.hl()) + buildWLParam(this.$wlDomain)).then(response => {
        if (!response.data || response.data.length === 0) {
          this.goTo('error', '&error_message=accessMethodError' + buildWLParam(this.$wlDomain))
          // go to error if error email not found show register button
        }
        if (response.data && response.data.length === 1 && response.data[0].url) {
          window.location.href = response.data[0].url
        }
        this.accessMethods = response.data
        this.completeLoginMethods()
        this.loginEmailSent = true
        this.loginStep = 'password'
      }, reject => {
        let err = reject.response ? reject.response.data ? reject.response.data.Error : 'rejected' : 'rejected'
        switch (true) {
          case err === 'invalid credentials':
            this.errorMessage = 'That Idonia account doesn\'t exist'
            this.errorLink =
              {
                label: 'get a new one',
                link: 'register.html?email=' +
                  encodeURIComponent(this.email) +
                  '&access_methods=' + this.urlStringMethods() +
                  '&default_login_methods=' + this.defaultLoginMethods() +
                  '&default_register_methods=' + this.defaultRegisterMethods() +
                  buildWLParam(this.$wlDomain)
              }
            break
          case typeof err === 'string' && err.includes('TooManyAttempts'):
            let errorData = err.split('^^')
            errorData = errorData[1] ? errorData[1] : '30'
            this.goTo('error', '&error_message=TooManyAttempts&error_data=' + errorData)
            break
          default:
            this.goTo('error', '&error_message=accessMethodError&statusCode=500&error=' + err)
        }
      }).catch(error => {
        this.$log.error(error)
        let err = error.response ? error.response.data ? error.response.data.Error : '' : ''
        this.goTo('error', '&error_message=accessMethodError&statusCode=500&error=' + err + buildWLParam(this.$wlDomain))
      })
    },
    randomString (length) {
      var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz'
      let result = ''

      while (length > 0) {
        var bytes = new Uint8Array(16)
        var random = window.crypto ? window.crypto.getRandomValues(bytes) : window.msCrypto.getRandomValues(bytes)

        random.forEach(function (c) {
          if (length === 0) {
            return
          }
          if (c < charset.length) {
            result += charset[c]
            length--
          }
        })
      }
      return result
    }
  }
}
